import _ from 'lodash';
import currencyToText from './CurrencyToText.js';

function formFieldPostfix({ field, transportationMethod, currency, val }) {
    let { postfix } = field;

    if (transportationMethod === 'sea') {
        postfix = postfix.replace(/chargeable weight/, 'W/M');
    } else if (transportationMethod !== 'air') {
        postfix = postfix.replace(/chargeable weight/, 'chargeable weight (Air) or W/M (Sea)');
    }

    return _.isUndefined(val) ? postfix.replace(/\[currency\]/, currencyToText(currency)) : postfix.replace(/\[currency\]/, currencyToText(currency, true, val));
}

export { formFieldPostfix };
